import React from 'react'

import { SVGIcon } from 'components/qstrap'
import CashSvg from 'components/atoms/SVGIcons/major/MajorCash'
import EarthSvg from 'components/atoms/SVGIcons/major/MajorEarth'
import MicrophoneSvg from 'components/atoms/SVGIcons/major/MajorMicrophone'
import LeafSvg from 'components/atoms/SVGIcons/major/MajorLeaf'
import LaptopSvg from 'components/atoms/SVGIcons/major/MajorLaptop'
import AtomSvg from 'components/atoms/SVGIcons/major/MajorAtom'
import BuildingSvg from 'components/atoms/SVGIcons/major/MajorBuilding'
import ForestSvg from 'components/atoms/SVGIcons/major/MajorForest'
import HatSvg from 'components/atoms/SVGIcons/major/MajorHat'
import PaintSvg from 'components/atoms/SVGIcons/major/MajorPaint'
import GraduationcapSvg from 'components/atoms/SVGIcons/major/MajorGraduationcap'
import BookSvg from 'components/atoms/SVGIcons/major/MajorBook'
import Uniform from 'components/atoms/SVGIcons/major/MajorUniform'
import BallSvg from 'components/atoms/SVGIcons/major/MajorBall'
import WaveSvg from 'components/atoms/SVGIcons/major/MajorWave'
import PalmTreeSvg from 'components/atoms/SVGIcons/major/MajorPalmtree'

const getMajorIcon = (name, width = 32, height = 32) => {
  switch (name) {
    case 'major-cash':
      return <CashSvg width={width} height={height} />
    case 'major-book':
      return <BookSvg width={width} height={height} />
    case 'major-microphone':
      return <MicrophoneSvg width={width} height={height} />
    case 'major-uniform':
      return <Uniform width={width} height={height} />
    case 'major-leaf':
      return <LeafSvg width={width} height={height} />
    case 'major-earth':
      return <EarthSvg width={width} height={height} />
    case 'major-atom':
      return <AtomSvg width={width} height={height} />
    case 'major-laptop':
      return <LaptopSvg width={width} height={height} />
    case 'major-building':
      return <BuildingSvg width={width} height={height} />
    case 'major-forest':
      return <ForestSvg width={width} height={height} />
    case 'major-hat':
      return <HatSvg width={width} height={height} />
    case 'major-paint':
      return <PaintSvg width={width} height={height} />
    case 'major-graduationcap':
      return <GraduationcapSvg width={width} height={height} />
    case 'major-ball':
      return <BallSvg width={width} height={height} />
    case 'major-wave':
      return <WaveSvg width={width} height={height} />
    case 'major-palmtree':
      return <PalmTreeSvg width={width} height={height} />
    default:
      return <SVGIcon size="md" name="common-course" />
  }
}

export default getMajorIcon
